import React, { useEffect, useState } from "react";
import axios from "axios";
import useAppData from "@/store/useAppData";
import { Module } from "../ItemList/types";

export interface CardLogicProps {
    title: string;
    suppressInit?: boolean;
}


const useCardLogic = ({
    title,
    suppressInit = false
}: CardLogicProps) => {

    const loggedUser = useAppData(state => state.user);

    const setSelectedModule = useAppData(state => state.setSelectedModule);
    const selectedModule = useAppData(state => state.selectedModule);
    const [modulesState, setModulesState] = useState<Module[]>([]);

    useEffect(() => {
        if (!suppressInit) {
            loadModules();
        }
    }, []);

    const loadModules = async () => {
        try {
            const res = await (
                axios({
                    method: "post",
                    url: "api/module/getAll",
                    data: {
                        ...(title === "Nastavení" ? {} : { userId: loggedUser?.id })
                    }
                })
            );

            if (res?.data?.modules?.length > 0) {

                if (!selectedModule || !res.data.modules.find(module => module.id === selectedModule.id)) {
                    setSelectedModule(res.data.modules[0]);
                }

                setModulesState(res.data.modules);
            }
        } catch (err) {
            throw err;
        }
    };

    const onChangeSelectedModule = async (e) => {
        setSelectedModule(modulesState.find(module => String(module.id) === e.target.value) ?? null);
    };

    return {
        modulesState,
        onChangeSelectedModule
    };
};

export default useCardLogic;